import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_Lpfn2tzW6yA3: {
	id: 'prd_Lpfn22DEV2tzW6yA3'
	ident: 'prd_Lpfn2tzW6yA3'
	sku: 'simple_premium_12w_15_99_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_D1JTQ2DEV2u8s4Mrv'
			amount: 79
			amount_usd: 15.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 15.99
			discount: 63.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_VqvVu2DEV2nK0trzI'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_Lpfn2tzW6yA3, SubscriptionProduct>
const prd_Lpfn2tzW6yA3 = { ident: 'prd_Lpfn2tzW6yA3' } as typeof _prd_Lpfn2tzW6yA3

export default prd_Lpfn2tzW6yA3
